import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
export function quitClaimDeclarationCloseCallback(app) {
    const caseNumber = app.$store.state.claim.claim.caseNumber;
    app.$buefy.dialog.confirm({
        animation: 'fade',
        title: app.$tc('claim.quit_declaration.title'),
        message: caseNumber
            ? app.$tc('claim.quit_declaration.message', 0, { caseNumber })
            : app.$tc('claim.quit_declaration.message.no_case_number'),
        onCancel: () => {
            // No-op
        },
        onConfirm: () => insurerHasFeature(InsurerFeatureFlag.AddContractNumberToCustomerAreaUrl) &&
            app.$store.state.contract.selectedContract.number
            ? app.$goBackHome(undefined, app.$store.state.contract.selectedContract.number)
            : app.$goToLocalePath('index'),
        confirmText: app.$tc('claim.quit_declaration.confirm'),
        cancelText: app.$tc('claim.quit_declaration.cancel'),
    });
}
// use mainly for claim that have strict no issue exit
export function quitClaimDeclarationNoConfirm(app) {
    app.$goToLocalePath('index');
}
export function goBackOneStep(app) {
    app.$store.dispatch('pages/goBackOneStep');
}
